<template>
  <v-app-bar class="wrapper-app-bar">
    <v-container
      class="wrapper-toolbar pa-0"
      :class="{ 'wrapper-toolbar-mobile': isMobile || isTablet }"
      :style="{ left: $vuetify.rtl ? '0' : '', right: !$vuetify.rtl ? '0' : '' }"
    >
      <!--TOGGLE-BTN-->
      <div class="toggle-btn">
        <div
          v-if="!isMobile && !isTablet"
          class="d-flex align-center toggle-icon"
          :class="{ rotate: isMenuToggle }"
          @click="menuToggle"
        >
          <my-icon
            :name="'toggle-icon'"
            :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
            :width="18"
            :height="18"
            :cursor-pointer="true"
          />
        </div>
        <div
          v-else-if="isMobile || isTablet"
          class="d-flex align-center toggle-icon"
          @click="mobileMenuToggle"
        >
          <v-icon>mdi-menu</v-icon>
        </div>
      </div>
      <div
        class="d-flex align-center"
        :class="{ 'gap-3': !isMobile || isTablet, 'gap-2': isMobile }"
      >
        <!--<v-btn
        color="secondary"
        outlined
        @click="goToPlans"
        >
          choose plan
        </v-btn>-->
        <v-btn
          v-if="!isMobile || isTablet"
          min-width="0"
          text
          small
          style="direction: rtl"
          color=""
          class="pa-0"
        >
          {{ today }}
        </v-btn>
        <v-menu bottom offset-y transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="0"
              text
              small
              v-bind="attrs"
              color=""
              :loading="loading"
              v-on="on"
              @click="getYears"
              class="pa-0"
            >
              {{ $t("Year") }} : {{ $store.state.year }}
            </v-btn>
          </template>
          <v-list :tile="false" nav>
            <v-list-item
              v-for="(year, i) in yearItems"
              :key="i"
              style="cursor: pointer"
              dense
              @click="changeYear(year)"
            >
              <v-list-item-title>{{ year.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="vertical-divider" v-if="!isMobile || isTablet"></div>
        <div class="d-flex align-center gap-3">
          <v-tooltip bottom v-if="!isMobile">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="resize"
                style="width: auto; height: auto"
              >
                <my-icon
                  :name="'resize-icon'"
                  :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
                  :width="18"
                  :height="18"
                  :cursor-pointer="true"
                />
              </v-btn>
            </template>
            <span>{{ $t("change-page-size") }}</span>
          </v-tooltip>
          <Updates v-if="!isMobile || isTablet" />
          <TemplateSetting v-if="!isMobile || isTablet" />
        </div>
        <div class="vertical-divider" v-if="!isMobile || isTablet"></div>
        <div class="d-flex align-center gap-3">
          <UserConversation />
          <UserFileProcess />
          <UserHelp />
          <UserSupport />
          <UserHistory />
        </div>
        <div class="vertical-divider" v-if="!isMobile || isTablet"></div>
        <UserPlan />
        <UserData />
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import UserData from "@/views/dashboard/components/core/partial/UserData.vue";
import UserHelp from "@/views/dashboard/components/core/partial/UserHelp.vue";
import UserSupport from "@/views/dashboard/components/core/partial/UserSupport.vue";
import UserHistory from "@/views/dashboard/components/core/partial/UserHistory.vue";
import UserConversation from "@/views/dashboard/components/core/partial/UserConversation.vue";
import UserFileProcess from "@/views/dashboard/components/core/partial/UserFileProcess.vue";
import TemplateSetting from "@/views/dashboard/components/core/partial/TemplateSetting.vue";
import Updates from "@/views/dashboard/components/core/partial/Updates.vue";
import moment from "moment-jalaali";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import UserPlan from "@/views/dashboard/components/core/partial/UserPlan.vue";

export default {
  data() {
    return {
      isMenuToggle: false,
      today: null,
      yearItems: [],
      loading: false,
    };
  },
  components: {
    UserData,
    UserHelp,
    UserSupport,
    UserHistory,
    UserConversation,
    UserFileProcess,
    TemplateSetting,
    Updates,
    UserPlan,
    MyIcon,
  },
  computed: {
    ...mapState(["isMenuExpanded"]),
  },
  methods: {
    goToPlans() {
      const userInfo = JSON.parse(localStorage.getItem("token"));
      if (userInfo.init.appBarsOpacity.abr) {
        this.$router.push({
          name: "plans",
          query: { abr: userInfo.init.appBarsOpacity.abr },
        });
      } else {
        console.warn("No token found in localStorage");
      }
    },
    menuToggle() {
      if (this.$store.state.isMenuExpanded) {
        this.$store.commit("SET_MENU_EXPANDED", false);
        document.documentElement.style.setProperty("--dynamic-width", "70px");
      } else {
        this.$store.commit("SET_MENU_EXPANDED", true);
        document.documentElement.style.setProperty("--dynamic-width", "200px");
      }
    },
    mobileMenuToggle() {
      const currentValue = this.$store.state.isMobileMenuOpen;
      this.$store.commit("SET_MOBILE_MENU", !currentValue);
    },
    resize() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        // Get the Shamsi year, month, and day using moment-jalaali
        const shamsiYear = m.jYear(); // Shamsi (Persian) year
        const shamsiMonth = m.jMonth() + 1; // Shamsi (Persian) month (starts from 1)
        const shamsiDay = m.jDate(); // Day number in Shamsi calendar

        // Get Persian month names
        const persianMonths = [
          "فروردین",
          "اردیبهشت",
          "خرداد",
          "تیر",
          "مرداد",
          "شهریور",
          "مهر",
          "آبان",
          "آذر",
          "دی",
          "بهمن",
          "اسفند",
        ];

        // Format the date as 'year/month/day' in Shamsi
        this.today = `${shamsiDay}/${persianMonths[shamsiMonth - 1]}/${shamsiYear}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        this.today = m.format("YYYY/MM/DD");
      }
    },
    getYears() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "year",
            search: null,
            page: 1,
          },
        })
        .then((res) => {
          res = res.data;
          app.yearItems = res.data;
          app.allYears = res.data;
          if (
            app.allYears &&
            app.allYears.length > 0 &&
            app.$store &&
            app.$store.state.financialYear &&
            app.$store.state.financialYear.id === app.allYears[0].id
          ) {
            app.$store.commit("SET_ISMAINYEAR", true);
          } else {
            app.$store.commit("SET_ISMAINYEAR", false);
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {
          /* this.serverErrorHandeler(err) */
        })
        .finally(() => (app.loading = false));
    },
    /*   changeYear (item) {
      if (this.$store.state.financialYear.id === item.id) return false
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'getdetail', {
        params: {
          select: 'changeYear',
          year: item
        }
      })
        .finally(() => (app.loading = false))
    }, */
    changeYear(item) {
      if (this.$store.state.financialYear.id === item.id) return false;
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "changeYear",
            year: item,
          },
        })
        .then((res) => {
          res = res.data;
          var storage = JSON.parse(localStorage.getItem("token"));
          storage.init.startDate = res.start_date;
          storage.init.endDate = res.end_date;
          storage.init.financialYear = res;
          storage.init.year = res.name;
          localStorage.setItem("token", JSON.stringify(storage));

          app.$store.commit("SET_YEAR", res.name);
          app.$store.commit("SET_FINANCIALYEAR", res);
          app.$store.commit("SET_START_DATE", res.start_date);
          app.$store.commit("SET_END_DATE", res.end_date);
          // app.$store.commit('CLEAR_COMPONENTS', [])
          location.reload();
        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {
          /* this.serverErrorHandeler(err) */
        })
        .finally(() => (app.loading = false));
    },
  },
  watch: {
    isMenuExpanded(val) {
      this.isMenuToggle = !this.isMenuToggle;
    },
    year(val, oldVal) {
      this.changeYear(val);
    },
  },
  mounted() {
    this.setToday();
    this.getYears();
    const isMenuExpanded = this.$store.state.isMenuExpanded;
    const dynamicWidth = isMenuExpanded ? "200px" : "70px";
    document.documentElement.style.setProperty("--dynamic-width", dynamicWidth);
  },
};
</script>

<style>
.wrapper-app-bar {
  height: 50px !important;
  padding: 0 8px;
  position: fixed;
  z-index: 3;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 0%), 0px 4px 5px 0px rgb(0 0 0 / 0%),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
}
.wrapper-app-bar .wrapper-toolbar {
  position: absolute;
  width: calc(100% - var(--dynamic-width));
  transition: width 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wrapper-app-bar .wrapper-toolbar.wrapper-toolbar-mobile {
  width: 100%;
}
:root {
  --dynamic-width: 200px;
}
.wrapper-app-bar .wrapper-toolbar .toggle-icon {
  transition: transform 0.3s ease-in-out;
  transform: rotate(0deg);
}
.wrapper-app-bar .wrapper-toolbar .toggle-icon.rotate {
  transform: rotate(180deg);
}
.wrapper-app-bar .v-toolbar__content {
  height: 50px !important;
  width: 100%;
}
.wrapper-app-bar .wrapper-toolbar .vertical-divider {
  border: 0.01rem solid #f0eeee82;
  height: 40px;
}
</style>
